import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "param"]
  static values = {
    url: String,
    errorMessage: String
  }

  async generate(event) {
    event.preventDefault()

    const button = event.currentTarget
    button.disabled = true
    button.classList.add("btn-disabled")
    button.setAttribute("aria-busy", "true")

    try {
      const response = await fetch(this.requestUrl(), {
        headers: { Accept: "application/json" }
      })

      if (!response.ok) throw new Error(`Request failed: ${response.status}`)

      const data = await response.json()
      this.inputTarget.value = data.code
      this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
      this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
      this.inputTarget.focus()
    } catch {
      window.alert(this.errorMessageValue)
    } finally {
      button.disabled = false
      button.classList.remove("btn-disabled")
      button.removeAttribute("aria-busy")
    }
  }

  requestUrl() {
    const url = new URL(this.urlValue, window.location.origin)

    this.paramTargets.forEach((target) => {
      const name = target.dataset.generatedCodeParamName
      if (name && target.value) url.searchParams.set(name, target.value)
    })

    return url.toString()
  }
}
